//
//
//
//
//
//
//
//
//
//
//
//
//
import tianjiaoScore from "./tianjiaoScore.vue";
import tianmojieying from "./tianmojieying.vue";
import zhenxieguyu from "./zhenxieguyu.vue";
export default {
  name: "tianjiaoScoreList",
  components: {
    tianmojieying: tianmojieying,
    tianjiaoScore: tianjiaoScore,
    zhenxieguyu: zhenxieguyu
  },
  mixins: [],
  data: function data() {
    return {
      activeIndex: 'tianjiaoScore'
    };
  },
  created: function created() {},
  activated: function activated() {},
  methods: {
    handover: function handover(index) {
      this.activeIndex = index;
    }
  }
};